<div class="app-full-height px-4 pt-4">
  <div
    class="flex flex-col lg:flex-row lg:space-x-4 lg:items-stretch lg:justify-start lg:space-y-0 space-y-4"
  >
    <mat-card appearance="outlined" class="lg:w-1/3 w-full">
      <mat-card-content>
        <h2>Customer</h2>
        <ngx-skeleton-loader
          *ngIf="customerLoading$ | async; else customerDetails"
          count="3"
          appearance="line"
        ></ngx-skeleton-loader>
        <ng-template #customerDetails>
          <ng-container *ngIf="customer$ | async as customer">
            <p>
              <a
                [testId]="testIds.CUSTOMER_NAME"
                matTooltip="View Customer"
                matTooltip-position="right"
                md-autohide="false"
                [routerLink]="['/customer', customer.id]"
              >
                {{ customer | customerName }}
              </a>
            </p>
            <p [testId]="testIds.CUSTOMER_ADDRESS">
              {{ customer | customerAddress }}
            </p>
            <p [testId]="testIds.CUSTOMER_CONACT_DETAILS">
              {{ customer | customerContactDetails }}
            </p>

            @if (docket$ | async; as docket) {
              <app-document-contact
                [contactId]="docket?.contact_id"
                [customerId]="docket?.customer_id"
                (contactSelected)="updateDocketContact($event)"
              ></app-document-contact>
            }
          </ng-container>
        </ng-template>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" class="lg:w-1/3 w-full">
      <mat-card-content class="text-center">
        <app-repair-docket-info
          [docketLoading]="docketLoading$ | async"
          [docket]="docket$ | async"
          (print)="print($event)"
        ></app-repair-docket-info>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" class="lg:w-1/3 w-full">
      <mat-card-content class="text-center lg:text-right">
        <app-repair-docket-settings></app-repair-docket-settings>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="flex flex-col w-full my-4">
    <mat-card>
      <mat-card-content class="text-center flex flex-col space-y-6">
        <h2 class="pb-4">Items</h2>
        <app-workshop-jobs-list
          [currency]="docketCurrency$ | async"
          [docketId]="docketId$ | async"
          [printFrame]="printFrame"
        ></app-workshop-jobs-list>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="flex flex-col lg:flex-row w-full my-4">
    <mat-card class="w-full lg:w-1/3 lg:ml-auto">
      <mat-card-content>
        <app-price-container-v2
          *ngIf="(docketLoading$ | async) === false"
          [canAddPayments]="true"
          [paymentableId]="(docket$ | async)?.id"
          [chargeableItems]="paymentContainerCharges$ | async"
          (paymentsChanged)="checkDocketStatus()"
          [currency]="docketCurrency$ | async"
        ></app-price-container-v2>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<iframe [style.display]="'none'" frameborder="0" #printFrame></iframe>
